import { render, staticRenderFns } from "./publicFocus.edit.vue?vue&type=template&id=652d320d&scoped=true"
import script from "./publicFocus.edit.vue?vue&type=script&lang=js"
export * from "./publicFocus.edit.vue?vue&type=script&lang=js"
import style0 from "./publicFocus.edit.vue?vue&type=style&index=0&id=652d320d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652d320d",
  null
  
)

export default component.exports